export default __webpack_public_path__ + "static/media/Th.f2cceea6.png";